import { api, centralApi } from '../../services/api';
import { User } from './types';

export const getUser = async (): Promise<User> => {
  const response = await api.get('/customer');
  return response.data.data;
};

// Com o segundo fator, a resposta do login vem sem token: traz o desafio
// (dois_fatores: true) e o código vai por e-mail. Sem ele, vem em data.
export const login = async (
  email: string,
  password: string,
  dispositivo?: string | null
) => {
  const response = await api.post<any>('customer/login', {
    email,
    password,
    dispositivo: dispositivo || undefined,
  });
  if (response.data && response.data.dois_fatores) {
    return response.data;
  }
  return response.data.data;
};

// Devolve o mesmo corpo do login ({ data: { api_token | customers } }) e, se
// pediu para lembrar, o token do dispositivo em "dispositivo".
export const confirmarCodigo = async (
  desafio: string,
  codigo: string,
  lembrar: boolean
) => {
  const response = await centralApi.post<any>('login/codigo', {
    desafio,
    codigo,
    lembrar,
  });
  return response.data;
};

export const reenviarCodigo = async (desafio: string) => {
  const response = await centralApi.post<any>('login/codigo/reenviar', {
    desafio,
  });
  return response.data;
};

export const recoverPassword = async (email: string) => {
  await api.patch('customer/recover-password', {
    email,
  });
};

export const sendNewPassword = async (password: string, token: string) => {
  await api.patch('customer/new-password', {
    password,
    token,
  });
};
